import { SectionProps } from './types'
import SecureInput from '../../../ui/SecureInput/SecureInput'
import { Link as LinkIcon } from 'lucide-react'

export default function SamlBearerSection({ form, styles }: SectionProps) {
  const { watch, setValue } = form
  return (
    <>
      <div className={styles.field}>
        <SecureInput
          fieldType="url"
          label="Token URL"
          icon={<LinkIcon size={16} />}
          value={watch('saml.token_url') || ''}
          onChange={(value) => setValue('saml.token_url', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Issuer (Entity ID)"
          value={watch('saml.issuer') || ''}
          onChange={(value) => setValue('saml.issuer', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Audience"
          value={watch('saml.audience') || ''}
          onChange={(value) => setValue('saml.audience', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Private Key (PEM)</label>
        <textarea
          value={watch('saml.private_key') || ''}
          onChange={(e) => setValue('saml.private_key', e.target.value)}
          className={styles.input}
          rows={4}
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Certificate (PEM)</label>
        <textarea
          value={watch('saml.certificate') || ''}
          onChange={(e) => setValue('saml.certificate', e.target.value)}
          className={styles.input}
          rows={4}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Client ID"
          value={watch('saml.client_id') || ''}
          onChange={(value) => setValue('saml.client_id', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Scope"
          value={watch('saml.scope') || ''}
          onChange={(value) => setValue('saml.scope', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="OAuth Client Username"
          value={watch('saml.client_username') || ''}
          onChange={(value) => setValue('saml.client_username', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="password"
          label="OAuth Client Password"
          value={watch('saml.client_password') || ''}
          onChange={(value) => setValue('saml.client_password', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Test NameID (optional)"
          description="Used only when clicking Test Connection. Real tool executions always use the signed-in end user's SAP IAS identity."
          value={watch('saml.testNameId') || ''}
          onChange={(value) => setValue('saml.testNameId', value)}
          className={styles.input}
        />
      </div>
    </>

  )
}
